<div class="default-shimmer">
    <!-- Title Skeleton -->
    <app-skeleton height="4vh" width="60vw"></app-skeleton>

    <!-- List of Skeleton Lines -->
    <app-skeleton *ngFor="let i of [1, 2, 3]; let idx = index; trackBy: trackByIndex" height="2.8vh" width="90vw"></app-skeleton>
</div>